<script setup lang="ts">
defineProps<{
  cellTotalsColor: string
  cellTotalsMax: number
  percentagesVisible: boolean
  commentIcon?: { icon: string; class: string }
}>();

const emit = defineEmits<{
  openDiscussion: []
}>();
</script>

<template>
  <div class="dm__cell-colorized" style="width: 100%; position: relative;">
    <div
      class="dm__cell-inner-bg"
      :style="`background: linear-gradient(to right, ${cellTotalsColor} ${cellTotalsMax}%, transparent 0%); display: flex !important; justify-content: center !important; align-items: center !important; height: 70px; width: 100%; text-align: center;`"
    >
      <template v-if="percentagesVisible && cellTotalsMax > 0">
        <div class="dm__cell-percentage" style="display: flex; justify-content: center; align-items: center;">
          <strong style="display: block; width: 100%;">{{ Math.round(cellTotalsMax) }}%</strong>
        </div>
      </template>
    </div>
    <button
      v-if="commentIcon"
      type="button"
      class="comment-btn"
      @click.stop="emit('openDiscussion')"
      title="Discuss this cell"
    >
      <i class="bi" :class="[commentIcon.icon, commentIcon.class]"></i>
    </button>
  </div>
</template>

<style scoped>
.dm__cell-colorized { width: 100%; }
.comment-btn {
  position: absolute;
  bottom: 4px;
  right: 4px;
  background: transparent;
  border: none;
  padding: 0;
  cursor: pointer;
  opacity: 0.7;
}
.comment-btn:hover {
  opacity: 1;
}
</style>
